import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import { Device } from "../../types/types";

export const useFetchDevices = () => {
  const setDevices = useAppStore((state) => state.setDevices);

  const [{ response: devicesData }, doFetchDevices] = useFetch("/devices/devices");

  useEffect(() => {
    let devices = devicesData?.data as unknown as Device[];
    if (devices) setDevices(devices);
  }, [devicesData]);

  return doFetchDevices;
};
